import React from 'react';
import SimpleBar from 'simplebar-react';

export interface TableScrollProps {
  children: any;
  maxHeight?: number | string;
}

const defaultProps = {};

function TableScroll(props: TableScrollProps) {
  return (
    <SimpleBar
      style={{
        display: 'flex',
        overflowX: 'hidden',
        flex: 1,
      }}>
      {props.children}
    </SimpleBar>
  );
}

TableScroll.defaultProps = defaultProps;

export default TableScroll;
